import React from "react";

import { ResponseType, OptionsType } from "commons/types/http";

import useHttpManaged from "hooks/useHttpManaged";

import { PathParamsWithId } from "commons/types/api/common";

import { SectionGalleryBody, SectionGalleryDetails } from "types/api/blocks/sectionGallery";

function useSectionGalleryApi() {
    const { get, del, post } = useHttpManaged();
    const getOneSectionGallery = React.useCallback((pathParams: PathParamsWithId, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<SectionGalleryDetails> => {
        return get<PathParamsWithId, undefined, SectionGalleryDetails>({
            url: "/blocks/section-gallery/:id",
            pathParams: pathParams,
            options: options,
            headers: headers
        });
    }, [get]);
    const saveSectionGallery = React.useCallback((body: SectionGalleryBody, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<null> => {
        return post<undefined, undefined, SectionGalleryBody, null>({
            url: "/blocks/section-gallery",
            body: body,
            options: options,
            headers: headers
        });
    }, [post]);
    const deleteSectionGallery = React.useCallback((pathParams: PathParamsWithId, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<null> => {
        return del<PathParamsWithId, undefined, null>({
            url: "/blocks/section-gallery/:id",
            pathParams: pathParams,
            options: options,
            headers: headers
        });
    }, [del]);
    return {
        getOneSectionGallery,
        saveSectionGallery,
        deleteSectionGallery
    };
}

export default useSectionGalleryApi;